import ISecondaryMarketReducer from '../interfaces/ISecondaryMarketReducer';
import {
  ADD_WALLETS_INFO,
  ADD_MARKET_SETTINGS,
  ADD_USER_DATA,
  RESET_LOCAL_STATE,
  RESTORE_LOCAL_STATE,
  SET_SERVER_PROPS,
  SET_SECONDARY_MARKET_DATA,
  SET_ASSET_DETAILS,
  UPDATE_ON_CANCEL_ORDER,
  SET_ASSETS_ASSET_DETAILS,
} from './actionTypes';
import { IOrder } from '@market/interfaces/IOrder';
import { EordersTypes } from '@market/enums/OrdersTypes';
import Big from 'big.js';
import ISPV from '@market/components/SPVsList/ISPV';
import ISPVsAsset from '@market/interfaces/ISPVsAsset';
import { sortOrdersByDateAsc } from './helpers/functions';

const initialState:ISecondaryMarketReducer = {
  userSignedIn: false,
  investorData: null,
  marketSettings: null,
  userWallets: undefined,
  spvs: undefined,
  tradesHistory: undefined,
  timestamp: 0,
};

let pastState:ISecondaryMarketReducer = initialState;
let localState:ISecondaryMarketReducer = initialState;

function reducer(state:ISecondaryMarketReducer = localState, action:any):ISecondaryMarketReducer {

  switch (action.type) {
    case RESET_LOCAL_STATE:
      pastState = { ...state };
      localState = { ...initialState };
      break;

    case RESTORE_LOCAL_STATE:
      localState = { ...pastState };
      break;

    case SET_SERVER_PROPS:
      localState = { ...localState, ...action.payload };
      break;

    case ADD_USER_DATA:
      localState = { ...localState, investorData: action.payload };
      break;

    case ADD_WALLETS_INFO:
      localState = { ...localState, userWallets: action.payload };
      break;

    case ADD_MARKET_SETTINGS:
      localState = { ...localState, marketSettings: action.payload };
      break;

    case SET_SECONDARY_MARKET_DATA:
      localState = {
        ...state,
        spvs: action.payload[0].data,
        marketSettings: action.payload[1] ? action.payload[1].data : initialState.marketSettings,
        userWallets: action.payload[2] ? action.payload[2].data : initialState.userWallets,
      };
      break;

    case UPDATE_ON_CANCEL_ORDER:
      localState = {
        ...state,
        spvs: localState.spvs ?
          localState.spvs.map((el: ISPV) => {
            if (el.trading_asset_id === action.payload.assetId) {
              const isSellOrder = EordersTypes.sell === action.payload.orderType;
              const orderShares = el.orderShares ? {
                ...el.orderShares,
                has_active_sell_orders: isSellOrder ? false : el.orderShares.has_active_sell_orders,
                has_active_buy_orders: !isSellOrder ? false : el.orderShares.has_active_buy_orders,
                assets:
                  isSellOrder ?
                    el.orderShares.assets.map((el: ISPVsAsset) => {
                      if (el.trading) {
                        return {
                          ...el,
                          sellable_number_of_shares: Number(new Big(action.payload.numberOfAvailableShares)
                            .plus(el.sellable_number_of_shares)),
                        };
                      }
                      return el;
                    }) : el.orderShares.assets,
              } : el.orderShares;

              return {
                ...el,
                orderShares,
                sellOrders:
                  isSellOrder && el.sellOrders ? el.sellOrders.filter((order: IOrder) => {
                    return order.id !== action.payload.orderId;
                  }) : el.sellOrders,
                buyOrders:
                  !isSellOrder && el.buyOrders ? el.buyOrders.filter((order: IOrder) => {
                    return order.id !== action.payload.orderId;
                  }) : el.buyOrders
                ,
              };
            }
            return el;
          }) : initialState.spvs,
      };
      break;

    case SET_ASSET_DETAILS:
      localState = {
        ...state,
        spvs: localState.spvs ?
          localState.spvs.map((el: ISPV) => {
            if (el.trading_asset_id === action.payload.assetId) {
              return {
                ...el,
                sellOrders: action.payload.res[0].sellOrders.data.sort(sortOrdersByDateAsc),
                buyOrders: action.payload.res[0].buyOrders.data.sort(sortOrdersByDateAsc),
                detailedCompanyAsset: action.payload.res[1].data,
                orderShares: action.payload.res[2].data,
              };
            }
            return el;
          }) : initialState.spvs,
        timestamp: Date.now(),
      };
      break;

    case SET_ASSETS_ASSET_DETAILS:
      localState = {
        ...state,
        spvs: [
          ...action.payload.res[0].data.map((el: ISPV) => {
            if (el.trading_asset_id === action.payload.assetId) {
              return {
                ...el,
                sellOrders: action.payload.res[1].sellOrders.data.sort(sortOrdersByDateAsc),
                buyOrders: action.payload.res[1].buyOrders.data.sort(sortOrdersByDateAsc),
                detailedCompanyAsset: action.payload.res[2].data,
                orderShares: action.payload.res[3].data,
              };
            }
            return el;
          }),
        ],
        tradesHistory: action.payload.res[4].data,
        marketSettings: action.payload.res[5].data,
        userWallets: action.payload.res[6].data,
        timestamp: Date.now(),
      };
      break;

    default:
      localState = { ...state };
  }

  return localState;
}

export default reducer;
